



































































































import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import {
 AddressOverride,
} from "@/admin/types";
import { Validator } from "vee-validate";

@Component ({
  components: {
  }
})
export default class AddressUpdate extends Vue {
  $validator: Validator;

  @Prop({required: true})
  address: AddressOverride;

  @Prop({required: true})
  override: boolean;

  @Prop({required: false, default: true})
  isPhysicalAddress: boolean;

  get address1Validation () {
    return { isNotPoBox: this.isPhysicalAddress, required: true, resemblesAddressLine: true };
  }

  get scope () {
    return this.isPhysicalAddress ? "physicalAddress" : "mailingAddress";
  }

  created () {
    this.$validator = this.$parent.$validator;
  }
}
